import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
import type { Moment } from 'moment';
import moment from 'moment';
import { DATE_FORMAT } from '../../constans';
import { useTranslation } from 'react-i18next';

interface DateRangePickerProps {
  startLabel?: string;
  endLabel?: string;
  startDate: string | null;
  endDate: string | null;
  onStartDateChange?: (date: string) => void;
  onEndDateChange?: (date: string) => void;
  className?: string;
  format?: string;
  hyphenOnly?: boolean
  removeLabel?: boolean
  disabled?: boolean
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
                                                           startLabel = 'class.class.column4',
                                                           endLabel = 'class.class.column5',
                                                           startDate,
                                                           endDate,
                                                           onStartDateChange,
                                                           onEndDateChange,
                                                           className = 'w-150p',
                                                           format = DATE_FORMAT.HYPHEN.YYYY_MM_DD,
                                                           hyphenOnly = false,
                                                           removeLabel = false,
                                                           disabled = false,
                                                         }) => {
  const [internalStart, setInternalStart] = useState<string | null>(startDate);
  const [internalEnd, setInternalEnd] = useState<string | null>(endDate);
  const { t } = useTranslation();

  useEffect(() => {
    setInternalStart(startDate);
  }, [startDate]);

  useEffect(() => {
    setInternalEnd(endDate);
  }, [endDate]);

  const handleStartChange = (date: Moment | null) => {
    if (date) {
      const formatted = date.format(format);
      setInternalStart(formatted);
      onStartDateChange && onStartDateChange(formatted);

      if (internalEnd && date.isSameOrAfter(moment(internalEnd))) {
        const newEnd = date.clone().add(1, 'days').format(format);
        setInternalEnd(newEnd);
        onEndDateChange && onEndDateChange(newEnd);
      }
    } else {
      setInternalStart(null);
      onStartDateChange && onStartDateChange('');
    }
  };

  const handleEndChange = (date: Moment | null) => {
    if (date) {
      const formatted = date.format(format);
      setInternalEnd(formatted);
      onEndDateChange && onEndDateChange(formatted);
    } else {
      setInternalEnd(null);
      onEndDateChange && onEndDateChange('');
    }
  };

  return (
    <div className={`flex comm-gap`} style={{ flexWrap: 'nowrap', alignItems: 'center', justifyContent: 'center' }}>
      {(!removeLabel) && <div>{t(startLabel)}</div>}
      <div className={`${className} date-picker__area`}>
        <DatePicker
          className="w-100"
          disabledDate={(current) =>
            internalEnd ? current && current >= moment(internalEnd) : false
          }
          value={internalStart ? moment(internalStart) : null}
          onChange={handleStartChange}
          disabled={disabled}
        />
      </div>

      {hyphenOnly && <div>~</div>}
      {(!removeLabel) && <div>{t(endLabel)}</div>}
      <div className={`${className} date-picker__area`}>
        <DatePicker
          className="w-100"
          disabledDate={(current) =>
            internalStart ? current && current <= moment(internalStart) : false
          }
          value={internalEnd ? moment(internalEnd) : null}
          onChange={handleEndChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
